import { FailedResponse } from "@miragon/react-utils-api";
import { ApiStateResponseError } from "../state/Store";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isApiStateResponseError(item: any): item is ApiStateResponseError {
    return "message" in item;
}

function getRawError(error: ApiStateResponseError | FailedResponse): string {
    if (isApiStateResponseError(error)) {
        return error.message;
    }
    return error.error;
}

export const renderError = (
    error: ApiStateResponseError | FailedResponse | undefined
): string | undefined => {
    if (!error) {
        return undefined;
    }


    switch (error.status) {
        case 400:
        case 401:
        case 403:
        case 404:
        case 409:
        case 500:
        case 502:
        case 503:
        case 504:
            return "Fehlercode HTTP " + error.status + ": " + getRawError(error);
        case -1:
        default:
            return "Unbekannter Fehler.";
    }
};
